<template>
	<div class="control-group input-address" :class="{filled: search, active: focused, error: errors && errors.length > 0, disabled: disabled}">
		<div class="control-holder">
			<label v-if="label" class="has-prepend">{{ label }}<span v-if="required">*</span></label>
			<div class="input has-prepend" :class="{'has-append': appendIcon}">
				<span @click.prevent="$emit('click:prepend')" class="prepend-icon">
					<icon icon="travel/mapping/location-pin-circle"></icon>
				</span>
				<div class="input-holder">
			        <input 
			        	ref="input"
				        type="text"
				        :disabled="disabled" 
				        :readonly="readonly"
				        v-model="search" 
				        :maxlength="(maxLength)?maxLength:null"
				        :minlength="(minLength)?minLength:null"
				        :placeholder="(placeholder)?(placeholder + ((required)?'*':'')):''" 
				        @click="$emit('focus')"
				        @focus="focused = true; $emit('focus')" 
				        @blur="focused = false; $emit('blur')" 
				        @change="$emit('change', $event)"
				        @keyup="$emit('keyup', $event)"
				        :inputmode="inputmode"
			        />
			    </div>
		    	<span v-if="appendIcon" @click.prevent="$emit('click:append', $event)" class="append-icon">
		    		<icon :icon="appendIcon"></icon>
		    	</span>
		    </div>
		</div>
        <transition name="slide-down">
            <div class="error-text" v-if="errors && errors.length > 0">
                <div v-for="error in errors">{{ error }}</div>
            </div>
        </transition>
    </div>
</template>

<script>
	export default {
		props: ['value', 'label', 'errors', 'required', 'placeholder', 'disabled', 'appendIcon', 'readonly', 'maxLength', 'minLength', 'inputmode', 'apiKey'],
		data() {
			return {
				address: this.value,
				search: '',
				focused: false,
				autocomplete: null
			}
		},
		watch: {
			async apiKey() {
				await this.setup();
			},
			address() {
				this.$emit('input', this.address);
				this.objectToSearch();
			},
			value() {
				this.address = this.value;
				this.objectToSearch();
			},
			search() {
				if(this.search === '') {
					['address', 'city', 'state', 'zip', 'country'].forEach((key) => {
						this.$set(this.address, key, null);
					});
				}
			}
		},
		methods: {
			async setup() {
				try {
					await this.$gmap(this.apiKey).load();
					this.autocomplete = new google.maps.places.Autocomplete(this.$refs.input);
		            this.autocomplete.setFields(['address_component']);
		            this.autocomplete.addListener('place_changed', this.setAddress);
				} catch(e) {
					console.error(e);
				}
			},
			focus() {
				this.$refs.input.focus();
			},
            setAddress() {
            	const result = this.autocomplete.getPlace();
            	if(!result.address_components) {
            		return;
            	}
            	let address = {};
            	result.address_components.forEach((component) => {
            		if(component.types.indexOf('street_number') !== -1){
                        address.number = component.short_name;
                    }
                    if(component.types.indexOf('route') !== -1){
                        address.street = component.short_name;
                    }
                    if(component.types.indexOf('locality') !== -1){
                        address.city = component.short_name;
                    }
                    if(component.types.indexOf('postal_town') !== -1){
                        address.city = component.short_name;
                    }
                    if(component.types.indexOf('administrative_area_level_1') !== -1){
                        address.state = component.short_name;
                    }
                    if(component.types.indexOf('postal_code') !== -1){
                        address.zip = component.short_name;
                    }
                    if(component.types.indexOf('country') !== -1){
                        address.country = component.short_name;
                    }
            	});
            	address.address = address.number + ' ' + address.street;
            	delete address.number;
            	delete address.street;
            	Object.keys(address).forEach((key) => {
            		this.$set(this.address, key, address[key]);
            	});
            },
            objectToSearch() {
            	this.search = '';
            	if(this.address.address) {
            		this.search += this.address.address + ', ';
            	}
            	if(this.address.city) {
            		this.search += this.address.city + ', ';
            	}
            	if(this.address.state) {
            		this.search += this.address.state + ', ';
            	}
            	if(this.address.zip) {
            		this.search += this.address.zip + ', ';
            	}
            	if(this.address.country) {
            		this.search += this.address.country;
            	}
            }
		},
		async mounted() {
			if(this.apiKey) {
				await this.setup();
				this.objectToSearch();
			}
		}
	}
</script>